export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $factsfigures = document.querySelectorAll('.ce__isnack-factsfigures-teaser');

        if (!$factsfigures.length) {
            return;
        }

        $factsfigures.forEach((teaser) => {
            const itemselectorH3 = '#' + teaser.id + ' h3';
            const itemselectorH2 = '#' + teaser.id + ' h2';
            const $equalHeightItemH3 = teaser.querySelectorAll(itemselectorH3);
            const $equalHeightItemH2 = teaser.querySelectorAll(itemselectorH2);

            if ($equalHeightItemH2.length > 0) {
                window.addEventListener('load', () => {
                    equalheight(itemselectorH2);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        equalheight(itemselectorH2);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        equalheight(itemselectorH2);
                    });
                });
            }

            if ($equalHeightItemH3.length > 0) {
                window.addEventListener('load', () => {
                    equalheight(itemselectorH3);
                    setTimeout(() => {
                        equalheight(itemselectorH3);
                    }, 500);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        equalheight(itemselectorH3);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        equalheight(itemselectorH3);
                    });
                });
            }
        });

        /* https://github.com/bfintal/Counter-Up2/tree/master */
        const counterUp = window.counterUp.default;

        const callback = (entries) => {
            entries.forEach((entry) => {
                const el = entry.target;
                if (entry.isIntersecting && !el.classList.contains('is-visible')) {
                    counterUp(el, {
                        duration: 2000,
                        delay: 16,
                    });
                    el.classList.add('is-visible');
                }
            });
        };

        const IO = new IntersectionObserver(callback, { threshold: 1 });

        const counterElements = document.querySelectorAll('.counter');

        counterElements.forEach((el) => {
            IO.observe(el);
        });
    });
}
